<template>
  <v-container>
    <v-row justify="space-between">
      <v-col cols="auto">
        <h1>资料标签管理</h1>
      </v-col>
      <v-col cols="auto" align-self="center">
        <v-btn color="primary" @click="showCreateTagDialog()">
          新增标签
        </v-btn>
      </v-col>
    </v-row>
    
    <v-data-table
      :headers="headers"
      :items="tags"
      :items-per-page="5"
      :loading="loading"
      class="elevation-1"
    >
      <template v-slot:[`item.actions`]="{ item }">
        <v-btn small @click="showEditTagDialog(item)">
          <v-icon>mdi-pencil</v-icon>
        </v-btn>
        <v-btn small @click="showDeleteTagConfirm(item)">
          <v-icon>mdi-delete</v-icon>
        </v-btn>
      </template>
    </v-data-table>

    <create-material-tag-popup 
    ref="createMaterialTagPopup"
    @tag-created="refresh"
    ></create-material-tag-popup>
    
    <edit-material-tag-popup
      ref="editMaterialTagPopup"
      :item="selectedTag"
      @tag-updated="refresh"
    ></edit-material-tag-popup>

    <delete-material-tag-confirmation
      ref="deleteMaterialTagConfirmation"
      :item="selectedTag"
      @tag-deleted="refresh"
    ></delete-material-tag-confirmation>
  </v-container>
</template>

<script>
import { materialApi } from '@/api/material'

export default {
  components: {
    CreateMaterialTagPopup: () => import('@/components/CreateMaterialTagPopup.vue'),
    DeleteMaterialTagConfirmation: () => import('@/components/DeleteMaterialTagConfirmation.vue'),
    EditMaterialTagPopup: () => import('@/components/EditMaterialTagPopup.vue')
  },
  created() {
    this.fetchTags();
  },
  data() {
    return {
      headers: [
        { text: "标签名称", value: "name" },
        { text: "创建时间", value: "createdDateTime" },
        { text: "操作", value: "actions", sortable: false },
      ],
      tags: [],
      selectedTag: {"name": "", "createdDate": ""},
      loading: false,
    }
  },
  methods: {
    showEditTagDialog(item) {
      this.selectedTag = item;
      this.$refs.editMaterialTagPopup.open(item);
    },
    showDeleteTagConfirm(item) {
      this.selectedTag = item;
      this.$refs.deleteMaterialTagConfirmation.open();
    },
    
    showCreateTagDialog() {
      this.$refs.createMaterialTagPopup.open();
    },

    refresh() {
      this.fetchTags();
    },

    async fetchTags() {
      this.loading = true;
      try {
        const response = await materialApi.getTags();
        console.log('tags response = ' , response);
        this.tags = response.data.map(tag => ({
          ...tag,
          id: tag.id,
          name: tag.name
        }));
      } catch (error) {
        const errorMessage = error.response?.data?.message || error.message || '未知错误';
        this.$toast.error('获取标签列表失败：' + errorMessage);
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style scoped>
.v-chip {
  margin-right: 8px;
}
</style>